export enum SingerData {
  Name = 'Singer Equipment Company',
  Address = '150 S. Twin Valley Road, Elverson, PA 19520'
}

export enum IweckData {
  Name = 'IEWC',
  Address = '-'
}

export enum FranklinData {
  Name = 'Franklin Paper',
  Address = '230 S broad St, Philadelphia PA 19102'
}

export enum BoelterData {
  Name = 'Boelter',
  Address = 'N22W23685 W Ridgeview Pkwy Waukesha, WI 53188'
}
